// authConfig.ts
import type { Configuration, PopupRequest } from "@azure/msal-browser";

// Hjälpare: välj rätt bas-URL för SPA:n (inte /api)
const getBaseUrl = () => {
  const env = import.meta.env.VITE_ENVIRONMENT; // t.ex. "mcapps-test" i din setup
  if (env === "mcapps-test") return "https://mcapps-test.multiconsult.no";
  if (import.meta.env.DEV) return "http://localhost:5173";
  return "https://multiplacer.multiconsult.no";
};

// MSAL-konfiguration för din SPA
export const msalConfig: Configuration = {
  auth: {
    clientId: "11ba4b4d-f4c8-4265-8ea0-44ca27e2c080",
    authority: "https://login.microsoftonline.com/81ab7478-8d3c-4736-8b54-7f2bfd9fa20e",
    // Redirect URIs måste exakt matcha dem du registrerat i Entra under SPA
    redirectUri: `${getBaseUrl()}/auth/callback`,
    postLogoutRedirectUri: `${getBaseUrl()}/auth/logout`,
  },
  cache: {
    // Vill du överleva reload/stängning? Använd localStorage. (Annars sessionStorage.)
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowPlatformBroker: false,
  },
};

export const loginRequest = {
  scopes: ["api://11ba4b4d-f4c8-4265-8ea0-44ca27e2c080/access_as_user"],
};

export const graphRequest = {
  scopes: ["User.Read"],
};
// Om du någon gång kallar Graph, håll denna separat
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
